<template>
  <div class="page bg-white">
    <div class="step-box">
      <div class="step active">
        <span class="circle">1</span>
        <span class="text">手机号码</span>
      </div>
      <div class="dash-line" :class="{ active: showBasicInfo }"></div>
      <div class="step" :class="{ active: showBasicInfo }">
        <span class="circle">2</span>
        <span class="text">身份信息</span>
      </div>
    </div>
    <BindingMobile
      v-if="!showBasicInfo"
      ref="bindingMobileRef"
      :telInput="telInput"
      :showChecked="true"
      @inputTelInfo="updTel"
    ></BindingMobile>
    <BindingBasicInfo v-else @updUserInfo="copyUserInfo" @submit="submit"></BindingBasicInfo>
    <p class="note" v-if="!showBasicInfo">感谢您选择智云医道，请完成身份信息填写以便正常使用我们的服务</p>
    <p class="note" v-if="!showBasicInfo">如遇登录问题，如收不到验证码，可于工作时间9:00~18:00，联系客服电话19155592439</p>
    <p class="note" v-else>
      为向您添加的就诊人提供预约挂号、问诊服务，您需要向我们提供该就诊人的身份证号码，并确保在提供前已取得该就诊人的授权同意；若该就诊人为儿童的，您需在提供前征得该儿童监护人的同意。
    </p>
    <van-button
      color="#1E8DFF"
      @click="bindMobile"
      class="submit-btn width-351"
      :disabled="!($util.isMobileValid(telInput.mobile) && $util.isMobileCodeValid(telInput.code))"
      v-if="!showBasicInfo"
    >
      下一步
    </van-button>
    <van-button
      color="#1E8DFF"
      @click="submit"
      class="submit-btn width-351"
      :disabled="
        !(userInfoCopy.name && userInfoCopy.sex && userInfoCopy.card && userInfoCopy.districtCode) || disableSubmit
      "
      v-else
    >
      提 交
    </van-button>
  </div>
</template>

<script>
import BindingBasicInfo from './components/BindingBasicInfo.vue';
import BindingMobile from '@/components/BindingMobile.vue';
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';

export default {
  name: 'BindingInfo',
  components: {
    BindingBasicInfo,
    BindingMobile
  },
  data() {
    return {
      mobileFirstBinded: false,
      telInput: {
        mobile: '',
        code: ''
      },
      userInfoCopy: {},
      disableSubmit: false
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.mobileBinded) {
        vm.askGetLocation();
      }
    });
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters(['mobileBinded', 'basicInfoFilled']),
    showBasicInfo() {
      return this.mobileBinded ? true : this.mobileFirstBinded;
      // return true;
    }
  },
  watch: {
    mobileBinded(val) {
      this.mobileFirstBinded = val;
    }
  },

  created() {
    this.$nextTick(() => {
      // 如果是从快速开方过来要 把 处方姓名渲染到用户姓名上
      const routerName = this.$route.query.name;
      if (routerName) {
        this.updUserInfo({
          name: routerName
        });
      }
    });
  },
  methods: {
    ...mapMutations(['updUserInfo']),
    ...mapActions(['getUserInfo']),
    updTel(data) {
      if (data.type == 'mobile') {
        this.telInput.mobile = data.value;
      }
      if (data.type == 'code') {
        this.telInput.code = data.value;
      }
    },
    copyUserInfo(data) {
      this.userInfoCopy = this.$util.clone(data);
    },
    bindMobile() {
      const checked = this.$refs.bindingMobileRef.checked;
      if (!checked) {
        this.$toast('请阅读并同意相关协议');
        return;
      }
      const { mobile, code } = this.telInput;
      const params = {
        mobile,
        verifyCode: code,
        verifyCodeType: 'BIND_PATIENT_MOBILE'
      };
      this.$fetch.updMobile(params).then((data) => {
        if (data.code == -102 || data.code == -107) {
          this.mobileFirstBinded = true;
          this.updUserInfo({ mobile });

          // 绑定手机号成功后获取地理位置
          this.$nextTick(() => {
            this.askGetLocation();
          });
        }
        if (data.code == -106) {
          this.$util.reAuth();
        }
      });
    },
    submit({ prescriptionId, from, userInfo }) {
      if (prescriptionId && from) {
        this.disableSubmit = true;
      }
      const params = this.$route.query;
      if (params.from && params.prescriptionId) {
        prescriptionId = params.prescriptionId;
        from = params.from;
      }

      const { name, card, sex, province, city, districtCode } = userInfo ? userInfo : this.userInfoCopy;

      // if (!this.$util.isNameValid(name)) {
      //   this.$toast('姓名为2-20字的中文字符');
      //   return;
      // }
      if (name.indexOf('先生') !== -1 || name.indexOf('女士') !== -1) {
        this.$toast('姓名中不能包含先生女士等特殊字符');
        return;
      }
      if (name && card && province) {
        // if (!this.$util.isIdCardValid(card)) {
        //   this.$toast('请输入正确身份证号码');
        //   return;
        // }
        this.$fetch
          .bindUserInfo({
            name,
            sex,
            card,
            province,
            city,
            districtCode,
            prescriptionId,
            from
          })
          .then(() => {
            this.$toast('信息提交成功');
            const jumpUrl = this.$route.query.jumpUrl;
            if (jumpUrl && jumpUrl != 'undefined' && jumpUrl != 'null') {
              this.$util.forceRedirect(jumpUrl);
            } else {
              window.wx.closeWindow();
            }
          });
      } else {
        this.$toast('请将信息填写完整');
      }
    },
    askGetLocation() {
      if (Object.keys(this.userInfo).length == 0) {
        window.wx.getLocation().then((res) => {
          if (res.errMsg === 'getLocation:ok') {
            this.$fetch.getUserLocation(res).then((res1) => {
              this.$store.dispatch('getUserInfo', res1);
            });
          }
        });
      } else {
        if (this.userInfo.districtCode) return;
        else
          window.wx.getLocation().then((res) => {
            if (res.errMsg === 'getLocation:ok') {
              this.$fetch.getUserLocation(res).then((res1) => {
                this.updUserInfo({
                  province: res1.addressComponent.province,
                  city: res1.addressComponent.city,
                  districtCode: res1.addressComponent.district
                });
              });
            }
          });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.page {
  position: relative;
  height: 100%;
  min-height: 500px;
  .submit-btn {
    position: absolute;
    bottom: 32px;
    left: 0;
  }
}
.step-box {
  display: flex;
  justify-content: center;
  padding: 20px 60px 44px;
  align-items: baseline;
}
.circle {
  display: block;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  font-size: 17px;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
  border: 1px solid rgba(204, 204, 204, 1);
  color: #cccccc;
  margin-left: 12px;
}
.text {
  font-size: 13px;
  font-weight: 400;
  color: rgba(204, 204, 204, 1);
  margin-top: 12px;
  display: inline-block;
  white-space: nowrap;
}

.active {
  .circle {
    background: rgba(73, 145, 253, 1);
    color: rgba(255, 255, 255, 1);
    border: 1px solid rgba(73, 145, 253, 1);
  }
  .text {
    color: #1e8dff;
  }
}
.dash-line {
  border-bottom: 1px dashed #ccc;
  width: 144px;
  margin-bottom: 10px;
  position: relative;
  top: -6px;
  left: 0;
}
.dash-line.active {
  border-bottom: 1px dashed #1e8dff;
}
.note {
  margin: 16px 12px 0;
  color: rgba(204, 204, 204, 1);
  line-height: 20px;
}
</style>
